import { render, staticRenderFns } from "./FullSizeColumn.vue?vue&type=template&id=0bf71d82&scoped=true&"
import script from "./FullSizeColumn.vue?vue&type=script&lang=ts&"
export * from "./FullSizeColumn.vue?vue&type=script&lang=ts&"
import style0 from "./FullSizeColumn.vue?vue&type=style&index=0&id=0bf71d82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf71d82",
  null
  
)

export default component.exports